import { Task } from '@/features/saveSite/types';
import { axios } from '@/lib/axios';
import { OutputErrorLog } from '@/lib/error';

export type PostTaskDTO = {
  task: Task;
  siteId: number;
  constructionZoneId: number;
};

// 作業保存API
export const createTask = async ({ task, siteId, constructionZoneId }: PostTaskDTO) => {
  try {
    return await axios.post(
      `/sites/${siteId}/construction-zones/${constructionZoneId}/tasks`,
      task
    );
  } catch (error) {
    OutputErrorLog('saveTask', error);
    throw error;
  }
};
